<template>
  <div class="questions-container">
    <div class="questions-content">
      <z-tabs
        :ellipsis="false"
        left
        class="questions-tab"
        v-model="activeTab"
        @change="handleTabChange"
      >
        <z-tab
          v-for="(el, index) in questionCateList"
          :title="el.questionCategoryName"
          :key="index"
          class="questions-tab-content"
        >
          <link-cell
            v-for="(qs, idx) in visibleOptionMap"
            :zz-sortid="`${curBizCate.businessCategoryId}-${index}-question-${idx}`" :zz-sortname="qs"
            :key="qs.questionId"
            :text="qs.questionName"
            :fromPage="recommandQuestions"
            :legoId="qs.questionId"
            :skillId="skillId"
            :athenaChannel="athenaChannel"
            :curBizCate="curBizCate"
          />
          <div class="refresh-bar" v-show="showRefreshIcon">
            <div class="refresh-bar-content" :zz-sortid="`${curBizCate.businessCategoryId}-${index}-change`" zz-sortname="换一批" @click="handleRefreshOptions">
              <z-icon class-prefix="zziconfont" name="refresh" class="updown-icon refresh-bar-icon"/>
              <span>换一批</span>
            </div>
          </div>
        </z-tab>
      </z-tabs>
      <!-- <span class="updown-container" @click="showMore" v-show="showUpdownIcon">
        <z-icon class-prefix="zziconfont" name="refresh" class="updown-icon"/>
      </span> -->
    </div>
  </div>
</template>

<script>
import { Tab, Tabs, Icon } from '@zz-common/zz-ui'
import LinkCell from '../LinkCell'
import { lego } from '@zz-common/lego'

export default {
  name: 'RecommendQuestions',
  props: {
    questionCateList: {
      type: Array,
      default: () => []
    },
    skillId: {
      type: String
    },
    athenaChannel: {
      type: String
    },
    curBizCate: {
      type: Object
    }
  },
  data() {
    return {
      activeTab: 0,
      iconName: 'unfold',
      visibleOptionMap: [],
      optionRefreshIndex: 0,
      totalOptions: [],
      maxVisibleCount: 6,
      recommandQuestions: 'RECOMMANDQUESTIONS'
    }
  },
  components: {
    zTabs: Tabs,
    zTab: Tab,
    zIcon: Icon,
    LinkCell
  },
  computed: {
    showRefreshIcon() {
      return this.totalOptions.length > this.maxVisibleCount
    }
  },
  watch: {
    curBizCate: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            try {
              const tabList = document.querySelectorAll('.z-tabs__nav .z-tab')
              tabList.forEach((item, index) => {
                item.setAttribute('zz-sortid', `${this.curBizCate.businessCategoryId}-tab-${index}`)
                item.setAttribute('zz-sortname', this.questionCateList[index].questionCategoryName)
              })
            } catch (error) {}
          })
        }
      }
    }
  },
  methods: {
    initOptions(activeTab) {
      const { listQuestionDtoList = [] } = this.questionCateList[activeTab] || {}
      this.totalOptions = listQuestionDtoList
      if (listQuestionDtoList.length >= this.maxVisibleCount) {
        this.handleRefreshOptions()
      } else {
        this.visibleOptionMap = listQuestionDtoList
      }
    },
    handleTabChange(val) {
      console.log('handleTabChange', val, this.questionCateList[val])
      this.totalOptions = this.questionCateList[val].listQuestionDtoList
      this.initOptions(val)
      lego.send({
        pagetype: 'NEWHELPCENTER',
        actiontype: 'NEWHELPCENTER_CHANGE_QUESTIONDTOLIST_CLICK',
        backup: {
          queDtoListItem: val,
          businessId: this.curBizCate.businessCategoryId
        }
      })
      // this.$nextTick(() => {
      //   try {
      //     const tabList = document.querySelectorAll('.z-tabs__nav .z-tab')
      //     tabList.forEach((item, index) => {
      //       item.setAttribute('zz-sortid', `${this.curBizCate.businessCategoryId}-tab-${index}`)
      //       item.setAttribute('zz-sortname', this.questionCateList[index].questionCategoryName)
      //     })
      //   } catch (error) {}
      // })
    },
    handleRefreshOptions() {
      const len = this.totalOptions.length
      const count = this.maxVisibleCount
      const curIndex = this.optionRefreshIndex
      // 每次还剩多少条
      const extra = len - curIndex
      // 剩余条数足够一页
      if (extra >= count) {
        this.visibleOptionMap = this.totalOptions.slice(curIndex, curIndex + count)
        this.optionRefreshIndex += count
      } else {
        // 剩余条数不足一页
        const exceed = Math.abs(extra)
        const last = this.totalOptions.slice(len - exceed, len)
        const pre = this.totalOptions.slice(0, count - exceed)
        this.visibleOptionMap = last.concat(pre)
        this.optionRefreshIndex = count - exceed
      }
    }
  },
  mounted() {
    console.log('mounted')
    this.initOptions(0)
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
